import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "space-y-1" }
const _hoisted_2 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-red-500 flex items-center"
}
const _hoisted_7 = {
  key: 1,
  class: "text-sm text-red-500 mt-2 flex items-center"
}
const _hoisted_8 = {
  key: 2,
  class: "text-sm text-green-600 mt-2 flex items-center"
}

import { ref, watch, onMounted } from 'vue'

interface Props {
  label?: string
  required?: boolean
  placeholder?: string
  modelValue: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountTitleField',
  props: {
    label: { default: 'Titulaire du compte' },
    required: { type: Boolean, default: false },
    placeholder: { default: 'Nom du titulaire du compte' },
    modelValue: {}
  },
  emits: ["update:modelValue", "validation-changed"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// État local
const inputValue = ref(props.modelValue)
const hasError = ref(false)
const isValid = ref(false)
const errorMessage = ref('')

// Validation de l'input
const validateInput = () => {
  const value = inputValue.value.trim()
  
  if (!value) {
    hasError.value = false
    isValid.value = false
    // Pour les champs requis, un champ vide n'est pas valide
    emit('validation-changed', false)
    return
  }
  
  // Validation : au moins 2 caractères
  if (value.length < 2) {
    hasError.value = true
    isValid.value = false
    errorMessage.value = 'Le titulaire du compte doit contenir au moins 2 caractères'
    emit('validation-changed', false)
    return
  }
  
  // Validation : pas plus de 255 caractères
  if (value.length > 255) {
    hasError.value = true
    isValid.value = false
    errorMessage.value = 'Le titulaire du compte ne peut pas dépasser 255 caractères'
    emit('validation-changed', false)
    return
  }
  
  // Validation réussie
  hasError.value = false
  isValid.value = true
  emit('validation-changed', true)
}

// Gestion de la saisie
const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  inputValue.value = target.value
  // Déclenche la validation
  validateInput()
}

// Synchronisation avec le v-model
watch(inputValue, (newValue) => {
  emit('update:modelValue', newValue)
})

// Synchronisation depuis le v-model externe
watch(() => props.modelValue, (newValue) => {
  inputValue.value = newValue
  // Toujours déclencher la validation, même si le champ est vide
  validateInput()
}, { immediate: true })

// Déclencher la validation au montage du composant
onMounted(() => {
  validateInput()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: _ctx.placeholder,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        onInput: handleInput,
        onBlur: validateInput,
        maxlength: 255,
        class: _normalizeClass(["w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200", hasError.value || (!inputValue.value && _ctx.required) ? 'border-red-500 bg-red-50' : isValid.value && inputValue.value ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-gray-400'])
      }, null, 42, _hoisted_5), [
        [_vModelText, inputValue.value]
      ]),
      (hasError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
          ]))
        : (!inputValue.value && _ctx.required)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }, null, -1),
              _createTextVNode(" Titulaire du compte obligatoire ")
            ])))
          : (isValid.value && inputValue.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "fas fa-check-circle mr-2" }, null, -1),
                _createTextVNode(" Titulaire du compte valide ")
              ])))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})